<template>
  <div ref="toggleRef" class="visibility-icon" data-testid="visibility-btn">
    <EyeIcon v-if="visible" class="m-auto w-5 h-5" />
    <EyeSlashIcon v-else class="m-auto w-5 h-5" />
  </div>
</template>

<script lang="ts" setup>
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid'

defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})
</script>

<style lang="stylus" scoped>
.visibility-icon
  @apply w-9 h-full flex place-items-center border-gray-700 bg-gray-800 cursor-pointer flex-shrink-0 select-none
</style>
